import React from 'react';

import { Image } from '../../Image/Image';
import styles from './NavImage.scss';
import classNames from 'classnames';
import { NavigationItemType } from '../itemTypes';
import { formatTestId } from '../../../../utils/test-id/format-testid';

type NavImageProps = {
  asAnchor?: boolean;
  label: string;
  url?: string;
  hierarchy: string[];
  handleClick?: () => void;
  imageUrl: string;
  itemType: NavigationItemType;
  tabIndex?: number;
};

export const NavImage = ({
  asAnchor,
  label,
  url,
  handleClick,
  hierarchy,
  imageUrl,
  itemType,
  tabIndex,
}: NavImageProps) => {
  const Wrapper = asAnchor ? 'a' : 'button';

  const isExternal = asAnchor && url && !url.startsWith('/');

  let width;
  let height;

  /* these are the width and height values going to the image API 
     - not the displayed dimensions
     they will be multiplied up based on pixel density 
     
     where the image is displayed at different sizes because it 
     scales to fit a range of widths within its breakpoint,
     an average is taken for simplicity

  */

  switch (itemType) {
    case NavigationItemType.BRAND_LOGOS:
      width = 221;
      height = 86;
      break;
    case NavigationItemType.IMAGE_GRID:
      width = height = 240;
      break;
    case NavigationItemType.WALL_LARGE:
      width = 313;
      height = 416;
      break;
    case NavigationItemType.WALL_SMALL:
      width = 154;
      height = 206;
      break;
    default:
      width = height = 220;
  }

  const showText = itemType !== NavigationItemType.BRAND_LOGOS;

  const anchorProps = {
    href: url,
    target: isExternal ? '_blank' : undefined,
    rel: isExternal ? 'noreferrer' : undefined,
  };

  return (
    <Wrapper
      onClick={handleClick}
      {...(asAnchor ? anchorProps : {})}
      tabIndex={tabIndex}
      data-testid={formatTestId(label, 'nav-')}
      data-hierarchy={hierarchy.join('|')}
      className={classNames(styles.wrapper, styles[itemType])}
      aria-label={
        label.endsWith('*')
          ? `${label.replace('*', '')} selected lines only`
          : label
      }
    >
      <Image url={imageUrl} label={label} width={width} height={height} />
      {showText && (
        <div className={styles.overlay}>
          <span>{label}</span>
        </div>
      )}
    </Wrapper>
  );
};
